import React, { useState, useEffect } from "react";
import { Modal, Button, Space, Input } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { TextArea } = Input;

const DeleteModal = ({
  title,
  subtitle,
  show,
  hide,
  onOk,
  loading,
  requireReason = false,
  reasonLabel = "Reason for deletion",
  reasonPlaceholder = "Please enter the reason for deleting this user...",
  okText = "Delete",
  cancelText = "Cancel",
  dangerOk = true,
}) => {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (show) setReason("");
  }, [show]);

  const handleOk = () => {
    if (requireReason) {
      const trimmed = (reason || "").trim();
      if (!trimmed) return;
      onOk(trimmed);
    } else {
      onOk();
    }
  };

  const canSubmit = !requireReason || (reason || "").trim().length > 0;

  return (
    <Modal
      open={show}
      onCancel={hide}
      footer={null}
      centered
      className="tab_modal"
      width={500}
    >
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <ExclamationCircleOutlined
          style={{ fontSize: "64px", color: "#ff4d4f", marginBottom: "16px" }}
        />
        <h4 className="modal_title_cls" style={{ marginBottom: "12px" }}>
          {title || "Confirm Delete"}
        </h4>
        <p style={{ marginBottom: requireReason ? "16px" : "24px", color: "#666" }}>
          {subtitle || "Are you sure you want to delete this item?"}
        </p>
        {requireReason && (
          <div style={{ textAlign: "left", marginBottom: "24px" }}>
            <label style={{ display: "block", marginBottom: "6px", fontWeight: 500 }}>
              {reasonLabel} <span style={{ color: "#ff4d4f" }}>*</span>
            </label>
            <TextArea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder={reasonPlaceholder}
              rows={3}
              maxLength={500}
              showCount
              style={{ resize: "none" }}
            />
          </div>
        )}
        <Space>
          <Button onClick={hide} style={{ minWidth: "100px" }}>
            {cancelText}
          </Button>
          <Button
            type="primary"
            danger={dangerOk}
            onClick={handleOk}
            loading={loading}
            disabled={!canSubmit}
            style={{ minWidth: "100px" }}
          >
            {okText}
          </Button>
        </Space>
      </div>
    </Modal>
  );
};

export default DeleteModal;
